import { ReactNode } from "react";

import { Icon } from "@chakra-ui/icons";
import { IoMdHome, IoMdPeople, IoMdSettings, IoMdStar, IoMdStats } from "react-icons/io";

import { AppConfig } from "../services/app-config-service";

export enum UserRole {
  User = "User",
  Admin = "Admin",
  SuperAdmin = "SuperAdmin"
}

// const allRoles = [UserRole.User, UserRole.Admin];

export interface MenuLink {
  label: string;
  path: string;
  target?: string;
  icon?: ReactNode;
  userRoles: UserRole[];
  superUserOnly?: boolean;
  requiresAuth?: boolean;
  disabledTooltip?: string;
}

export const TopMenuLinks: MenuLink[] = [
  // { label: "Team", path: "https://www/our-team", target: "_blank", userRoles: allRoles }
];

export let SideMenuLinks: MenuLink[] = [
  { label: "Home", path: "/", icon: <Icon as={IoMdHome} />, userRoles: [UserRole.User] },
  {
    label: "Members",
    path: "/members",
    icon: <Icon as={IoMdPeople} />,
    userRoles: [UserRole.User],
    requiresAuth: true,
    disabledTooltip: "Please log in to manage members"
  },
  {
    label: "Health Metrics",
    path: "/health-metrics/ph-analysis",
    icon: <Icon as={IoMdStats} />,
    userRoles: [UserRole.User]
  }
];

export const PrivateSideMenuLinks: MenuLink[] = [
  { label: "Demo", path: "/demo", icon: <Icon as={IoMdStar} />, userRoles: [UserRole.User] }
];

export const SuperuserMenuLink: MenuLink = {
  label: "Superuser",
  path: "/superuser",
  icon: <Icon as={IoMdSettings} />,
  userRoles: [UserRole.SuperAdmin],
  superUserOnly: true
};

// TODO: Remove this once we go live with profile-driven conversations
if (AppConfig.shouldHideWipFeatures) {
  SideMenuLinks = SideMenuLinks.filter((link) => link.label !== "Profile");
}
